export const Table = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="24" height="24" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M4 10H28" stroke="currentColor" stroke-width="2"/>
<path d="M4 16H28" stroke="currentColor" stroke-width="2"/>
<path d="M4 22H28" stroke="currentColor" stroke-width="2"/>
</svg>`;
